const GQLFetch = (query, clientID, token) => {
  const myHeader = new Headers();
  if(clientID) myHeader.append("X-API-CLIENT-ID", clientID);
  if(token) myHeader.append("X-API-TOKEN",token)
  myHeader.append("Accept", "application/json");
  myHeader.append("Content-Type", "application/json");
  myHeader.append("Authorization", "Bearer e462cdabc9b0ba42500c5a5ce49525434e3b1a5ec89f950f49f9f6c9172b366c")
  const myInit = {
    method: "POST",
    headers: myHeader,
    body: JSON.stringify({
      query: query
    })
  }
  const myRequest = new Request(`${process.env.REACT_APP_URL || 'https://apizen.ticfood.com'}/graphql/`, myInit); return fetch(myRequest).then(res => res.json());
}
export default GQLFetch;